import React, { useEffect, useState } from 'react';
import { getElementIntersection } from 'lib/get-element-intersection.js';
import { CountdownIndicator } from '../countdown-indicator/index.js';

export function useAutoClick(targetRef, predicate, options) {
  const [indicator, setIndicator] = useState(null);

  useEffect(() => {
    if (!predicate) {
      return setIndicator(null);
    }
    const {
      appearance,
      timeout,
      width,
      /*
            borderRadius,
      */
      onTimeout,
    } = options;

    getElementIntersection(targetRef.current).then((intersectionEntry) => {
      const { boundingClientRect: rect } = intersectionEntry;

      if (!targetRef.current) {
        return;
      }
      const { borderRadius } = getComputedStyle(targetRef.current);
      const strokeWidth = appearance?.default?.lineWidth ?? rect.width * 0.05;
      const strokeGap = appearance?.default?.gap ?? 0;

      setIndicator(
        <CountdownIndicator
          width={rect.width}
          height={rect.height}
          borderRadius={parseInt(borderRadius)}
          strokeWidth={strokeWidth}
          strokeGap={strokeGap}
          timeout={timeout}
          originalWidth={width}
          onComplete={onTimeout}
        />,
      );
    });
  }, [options, predicate, targetRef]);

  return indicator;
}
